import { render, staticRenderFns } from "./refuse.vue?vue&type=template&id=8cd05958&scoped=true"
import script from "./refuse.vue?vue&type=script&lang=js"
export * from "./refuse.vue?vue&type=script&lang=js"
import style0 from "./refuse.vue?vue&type=style&index=0&id=8cd05958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd05958",
  null
  
)

export default component.exports